import { Autocomplete } from '@react-google-maps/api'
import { isObject } from 'lodash'
import { Form } from 'react-bootstrap'

interface DropdownType {
  name: string
  value: string | number
}

interface Props {
  title?: string
  buttonTitle?: string
  icon?: string
  type: string
  onLoadPlaces?: any
  onPlacesChanged?: any
  dropdownMenu?: string[] | DropdownType[]
  handleChange?: any
  name?: string
  handleSubmit?: any
  value?: string | number | boolean | any
}

function NavigationButton({
  title,
  buttonTitle,
  icon,
  type,
  onLoadPlaces,
  onPlacesChanged,
  dropdownMenu,
  handleChange,
  name,
  handleSubmit,
  value,
}: Props) {
  return (
    <>
      {title && <p>{title}</p>}

      {type === 'button' && (
        <button onClick={handleSubmit}>
          <span className='icon-wrapper'>
            <i className={`fa-solid fa-${icon}`} />
          </span>
          <span className='button-text'>{buttonTitle}</span>
        </button>
      )}
      {type === 'select' && (
        <Form.Select value={value} name={name} onChange={handleChange}>
          {buttonTitle && <option>{buttonTitle}</option>}

          {dropdownMenu?.map((item, index) =>
            isObject(item) ? (
              <option value={item.value} key={index}>
                {item.name}
              </option>
            ) : (
              <option value={item} key={index}>
                {item}
              </option>
            ),
          )}
        </Form.Select>
      )}
      {type === 'input' && (
        <div className='autocomplete-wrapper'>
          <Autocomplete
            restrictions={{ country: 'CH' }}
            types={['(cities)']}
            className='autocomplete-input'
            onLoad={onLoadPlaces}
            onPlaceChanged={onPlacesChanged}
          >
            <input
              type='text'
              className='form-control'
              placeholder={buttonTitle}
              required
              value={value}
              name='city'
              onChange={handleChange}
              min='1'
            />
          </Autocomplete>
        </div>
      )}
    </>
  )
}
export default NavigationButton
